import { withLazyProviders } from "@/components/Layouts/with-lazy-providers"
import { Metadata } from "@/components/Metadata"
// import SignInModalV2 from "@/components/ModalsPortal/SignInModalV2"
// import SignUpModalV2 from "@/components/ModalsPortal/SignUpModalV2"
import SidebarDrawerMobile from "@/components/Workspace/Sidebar/SidebarDrawerMobile"
import MobileNavigation from "@/components/common/MobileNavigation"
import { clientUrl } from "@/constants"
import SafeAreaView from "@/providers/SafeAreaView"
import dynamic from "next/dynamic"
import useCustomRouter from "@/hooks/useCustomRouter"
import { useEffect } from "react"

const SignInModalV2 = dynamic(() => import("@/components/ModalsPortal/SignInModalV2"))
const SignUpModalV2 = dynamic(() => import("@/components/ModalsPortal/SignUpModalV2"))

function Home() {
  const router = useCustomRouter()

  useEffect(() => {
    if (!router.isReady) return
    if (!router.query.signIn && !router.query.signUp) {
      router.replace(
        {
          query: {
            ...router.query,
            signIn: true,
          },
        },
        undefined,
        {
          shallow: true,
        },
      )
    }
  }, [router.isReady])

  return (
    <>
      <Metadata title="GAIA | Auth" url={`${clientUrl}/auth`} description="GAIA" type="website" />
      <SafeAreaView
        as="main"
        id="layout"
        className="relative overflow-hidden h-screen min-h-[40rem] bg-blackAlpha-600 flex justify-center items-center text-atherGray-0"
      >
        <SignInModalV2 onClose={() => router.replace("/")} />
        <SignUpModalV2 onClose={() => router.replace("/")} />
        <MobileNavigation className="z-[51]" />
        <SidebarDrawerMobile className="z-[51]" />
      </SafeAreaView>
    </>
  )
}

export default withLazyProviders(Home)
